import { render, staticRenderFns } from "./gaming.vue?vue&type=template&id=303f67c0&"
import script from "./gaming.vue?vue&type=script&lang=js&"
export * from "./gaming.vue?vue&type=script&lang=js&"
import style0 from "./gaming.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopScreen: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/TopScreen.vue').default,FooterTop: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/footer/footerTop.vue').default})
